export default __webpack_public_path__ + "static/media/173.0eb8768b.png";